import { License, SystemModuleLicense } from "../../api/api-generated";
import FileSaver from "file-saver";

export const downloadLicense = (
  softwareName: string,
  companyName: string,
  licenses: License[]
) => {
  const softwareAbbreviation = getSoftwareAbbreviationFromName(softwareName);
  const licenseName = getLicenseName(companyName, softwareAbbreviation);
  let licenseText = "";
  if (softwareAbbreviation === "LSM" || softwareAbbreviation === "ASM") {
    licenseText = getLsmAsmLicenseText(licenses);
  } else {
    licenseText = getOtherLicenseText(licenses);
  }
  const fileBlob = new Blob([licenseText], {
    type: "text/plain;charset=utf-8",
  });
  FileSaver.saveAs(fileBlob, licenseName);
};

export const downloadSystemModule = (
  licenses: SystemModuleLicense[],
  companyName: string
) => {
  const licenseName = getLicenseName(companyName, "SpectrasSystemModules");
  const licenseObject: { iv: string; modules: { [key: string]: string } } = {
    iv: licenses[0].iv,
    modules: {},
  };
  for (const item of licenses) {
    licenseObject.modules[item.module] = item.license;
  }
  const licenseText = JSON.stringify(licenseObject);
  const fileBlob = new Blob([licenseText], {
    type: "text/plain;charset=utf-8",
  });
  FileSaver.saveAs(fileBlob, licenseName);
};

export const getSoftwareAbbreviationFromName = (fullName: string): string => {
  if (fullName.toLowerCase().includes("web")) return "WEB";
  if (fullName.toLowerCase().includes("lsm")) return "LSM";
  if (fullName.toLowerCase().includes("asm")) return "ASM";
  if (fullName.toLowerCase().includes("spectrum")) return "Spectrumnet";
  if (fullName.toLowerCase().includes("leo")) return "LEO";
  return "none";
};

export const getLsmAsmLicenseText = (licenses: License[]) => {
  const header = "AAAAHHicy/MNdAlwLHfyqfAN8XbRD/UtM7BIzoxwdgQCAIHnCKk=";
  const fileText = licenses.reduce(
    (acc, cur) => acc + "\r\n" + cur.license,
    header
  );
  return fileText;
};

export const getOtherLicenseText = (licenses: License[]) => {
  const fileText = licenses.reduce(
    (acc, cur) => acc + cur.license + "\r\n",
    ""
  );
  return fileText;
};

export const getLicenseName = (companyName: string, softwareName: string) => {
  const companyNameNoPunctuation = companyName.replace(
    /[.,/#!$%^&*;:{}=\-_`~()]/g,
    ""
  );
  const fileName =
    companyNameNoPunctuation.replace(/ /g, "_") + "_" + softwareName + ".lic";
  return fileName;
};
